module.exports = __webpack_public_path__ + "static/media/biSPIRIT.a4a8fb47.png";